import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

const MarkdownText = ({ source, style }) => {
    if (!source) return null;

    const lines = source.split('\n');
    const elements = [];
    let i = 0;
    let listBuffer = [];

    const flushList = () => {
        if (listBuffer.length === 0) return;
        elements.push(
            <View key={`list-${i}`} style={styles.list}>
                {listBuffer.map((item, idx) => (
                    <View key={idx} style={styles.listItem}>
                        <Text style={styles.bullet}>•</Text>
                        <Text style={styles.listItemText}>{renderInline(item)}</Text>
                    </View>
                ))}
            </View>
        );
        listBuffer = [];
    };

    const renderInline = (text) => {
        const parts = [];
        const regex = /\*\*(.*?)\*\*/g;
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                parts.push(<Text key={`t-${lastIndex}`}>{text.slice(lastIndex, match.index)}</Text>);
            }
            parts.push(<Text key={`b-${match.index}`} style={styles.bold}>{match[1]}</Text>);
            lastIndex = match.index + match[0].length;
        }
        if (lastIndex < text.length) {
            parts.push(<Text key={`t-end`}>{text.slice(lastIndex)}</Text>);
        }
        return parts.length ? parts : text;
    };

    while (i < lines.length) {
        const line = lines[i];
        const trimmed = line.trim();

        if (trimmed.startsWith('# ')) {
            flushList();
            elements.push(
                <Text key={`h1-${i}`} style={styles.h1}>
                    {renderInline(trimmed.slice(2))}
                </Text>
            );
        } else if (trimmed.startsWith('## ')) {
            flushList();
            elements.push(
                <Text key={`h2-${i}`} style={styles.h2}>
                    {renderInline(trimmed.slice(3))}
                </Text>
            );
        } else if (trimmed.startsWith('- ')) {
            listBuffer.push(trimmed.slice(2));
        } else if (trimmed === '' && listBuffer.length > 0) {
            flushList();
        } else if (trimmed === '') {
            // blank line, skip
        } else {
            flushList();
            elements.push(
                <Text key={`p-${i}`} style={styles.paragraph}>
                    {renderInline(trimmed)}
                </Text>
            );
        }
        i++;
    }
    flushList();

    return (
        <View style={[styles.container, style]}>
            {elements}
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    container: {
        gap: spacing.sm,
        flexShrink: 1,
    },
    h1: {
        fontFamily: fonts.bold,
        fontSize: typography.h1,
        color: colors.text,
        marginBottom: spacing.xs,
    },
    h2: {
        fontFamily: fonts.heading,
        fontSize: typography.h2,
        color: colors.text,
        marginBottom: spacing.xs,
    },
    paragraph: {
        fontFamily: fonts.body,
        fontSize: typography.body,
        color: colors.text,
        lineHeight: 22,
        flexShrink: 1,
    },
    bold: {
        fontFamily: fonts.bold,
    },
    list: {
        gap: spacing.xs,
        marginLeft: spacing.sm,
    },
    listItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: spacing.sm,
    },
    bullet: {
        fontFamily: fonts.body,
        fontSize: typography.body,
        color: colors.primary,
        lineHeight: 22,
    },
    listItemText: {
        flex: 1,
        fontFamily: fonts.body,
        fontSize: typography.body,
        color: colors.text,
        lineHeight: 22,
    },
}));

export default MarkdownText;
